module.exports = __webpack_public_path__ + "static/7-08fdfceb23aa4b53638f6bb22f9524c3.jpeg";